<template>
    <div v-if="isLoading" class="global-spinner">
      <div class="spinner"></div>
    </div>
  </template>
  
  <script>
  import { computed } from "vue";
  import { useLoadingState } from "@/store/loadingState.module";
  
  export default {
    name: "GlobalSpinner",
    setup() {
      const loadingState = useLoadingState();
  
      return {
        isLoading: computed(() => loadingState.isLoading),
      };
    },
  };
  </script>
  
  <style scoped>
  .global-spinner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s ease infinite;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  </style>
